import AxiosClientWrapper from './apiClient';

import { ARYABHATTA_API_DOMAIN_V1, DOCS_API_DOMAIN } from 'config';

const ABClient = new AxiosClientWrapper(ARYABHATTA_API_DOMAIN_V1);

const DocClient = new AxiosClientWrapper(DOCS_API_DOMAIN);

export { ABClient, DocClient };
